import React from "react";
import { SRLWrapper } from "simple-react-lightbox";

interface IProps {
  gallery: string[];
}

const MovieGallery: React.FC<IProps> = ({ gallery }: IProps) => {
  return (
    <SRLWrapper>
      {gallery.map((item, index) => (
        <React.Fragment key={index}>
          <img className={"movie-photo"} src={item} alt={"zdj"} />
        </React.Fragment>
      ))}
    </SRLWrapper>
  );
};

export default MovieGallery;
